import { render, staticRenderFns } from "./SchemaModule.vue?vue&type=template&id=2c8470c0&scoped=true&"
import script from "./SchemaModule.vue?vue&type=script&lang=js&"
export * from "./SchemaModule.vue?vue&type=script&lang=js&"
import style0 from "./SchemaModule.vue?vue&type=style&index=0&id=2c8470c0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8470c0",
  null
  
)

export default component.exports